import classNames from "classnames"
import PropTypes from "prop-types"
import React, { useState } from "react"

import Invoice from "./Invoice"

const PAY_NOW_GROUP = "due_now"

const InvoiceGroup = ({ groupKey, invoices, heading, subheading }) => {
  const [isExpanded, setIsExpanded] = useState(true)

  return (
    <div className="card px-2" data-testid={`${groupKey}-invoices`}>
      <div className="flex items-center justify-between px-2">
        <div>
          <div className="text-xl font-bold">{heading}</div>
          <div className="text-muted text-sm">{subheading}</div>
        </div>
        {invoices.length > 0 ? (
          <div
            className="flex h-8 w-8 cursor-pointer rounded-full bg-gray-200 text-xs text-gray-600"
            onClick={() => setIsExpanded(!isExpanded)}
          >
            <i
              className={classNames("icon m-auto", {
                "icon-angle-down": isExpanded,
                "icon-angle-up": !isExpanded,
              })}
            />
          </div>
        ) : null}
      </div>
      <div
        className={classNames({
          "block divide-y": isExpanded,
          hidden: !isExpanded,
        })}
      >
        {invoices.map((invoice) => (
          <Invoice
            invoice={invoice}
            payNowSupported={groupKey === PAY_NOW_GROUP}
            key={invoice.id}
          />
        ))}
      </div>
    </div>
  )
}

InvoiceGroup.propTypes = {
  groupKey: PropTypes.string.isRequired,
  invoices: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }).isRequired
  ),
  heading: PropTypes.string.isRequired,
  subheading: PropTypes.string.isRequired,
}

export default InvoiceGroup
